<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('electronicReceiptTwo_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('electronicReceiptTwo_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      show-footer
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="mainOrderNumber"
          title="货源单号"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.mainOrderNumber"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="orderDetailNumber"
          title="运输单号"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderDetailNumber"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="bizOrderNo"
          title="支付流水"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.bizOrderNo"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="receiptNo"
          title="电子回单编号 "
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.receiptNo"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="totalAmount"
          title="金额"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.totalAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.totalAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="outAccountId"
          title="付款方账户"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.outAccountId"
            placeholder="请输入付款方账户"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="outName"
          title="付款方姓名"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.outName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="inAccountId"
          title="收款方账号"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.inAccountId"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="inName"
          title="收款方名称"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="listQuery.inName" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="isShare"
          title="是否清分"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'isShare')
          "
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.isShare" placeholder="请选择" clearable>
            <el-option
              v-for="item in parentData.isShareOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="splitAccountId"
          title="清分方账号"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.splitAccountId"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="splitName"
          title="清分方姓名"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.splitName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="teamAmount"
          title="清分金额"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.teamAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.teamAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="source"
          title="支付来源"
          min-width="190"
          sortable
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'source')
          "
        />
        <template v-slot:header>
          <el-select v-model="listQuery.source" placeholder="请选择" clearable>
            <el-option
              v-for="item in parentData.sourceOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="balancePayType"
          title="付款方式"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'balancePayType')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.balancePayType"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.balancePayTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="status"
          title="支付状态"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'status')
          "
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.status" placeholder="请选择" clearable>
            <el-option
              v-for="item in parentData.statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="electronicReceipt"
          title="电子回单状态"
          min-width="130"
          :formatter="
            ({ cellValue }) =>
              formatterField({ cellValue }, 'electronicReceipt')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.electronicReceipt"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.electronicReceiptOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column field="memo" title="备注" min-width="190" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.memo" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="orderGmtCreatedRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" width="60px" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('electronicReceiptTwo_lookReceipt_button')"
            class="item"
            effect="dark"
            content="查看回单"
            placement="top"
          >
            <vxe-button type="text" @click="lookReceipt(scope.row.code)">
              <i class="el-icon-paperclip" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <displayImg ref="displayImg" />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { lookReceiptTwo, arpaTransferTwo } from "@/api/InternetBanking";
import { getLimit } from "@/utils/getLimit.js";
import displayImg from "./components/displayImg";
export default {
  name: "PaymentHistory",
  components: {
    displayImg
  },
  data() {
    return {
      partyType: this.$store.getters.party.partyType,
      callbackTimeRange: "",
      loading: false,
      exportObj: {
        exportUrl: "/ntocc-tms-api/arpaTransfer/exportArpaTransferList", //导出接口
        name: "电子回单"
      },
      tableData: [],
      ModelCashMoney: false,
      showElectronicReceiptUrl: "",
      parentData: {},
      orderGmtCreatedRange: "",
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        isPayAdvance: "0"
      },
      accdata: [],
      // 机构列表
      branchList: this.$store.state.components.branchList,
      sumObject: {}
    };
  },
  created() {
    this.parentData.balancePayTypeOptions = [
      { label: "打款", value: 0 },
      { label: "预付", value: 1 }
      // { label: "车队分账", value: 2 },
    ];
    this.parentData.sourceOptions = [
      { label: "托运人", value: "shipment" },
      { label: "实际承运人", value: "driver" },
      { label: "平台", value: "platform" }
    ];
    this.parentData.electronicReceiptOptions = [
      { label: "可申请", value: 0 },
      { label: "已申请", value: 1 }
    ];
    this.parentData.isShareOptions = [
      { label: "否", value: 0 },
      { label: "是", value: 1 }
    ];
    this.parentData.statusOptions = [
      { label: "成功", value: "SUCCESS" },
      { label: "失败", value: "FAIL" },
      { label: "处理中", value: "DEALING" },
      { label: "退款失败", value: "REFUNDFAIL" },
      { label: "退款成功", value: "REFUNDED" },
      { label: "退款中", value: "REFUNDING" }
    ];
    this.paymentHistory_search_button = getLimit(
      "paymentHistory_search_button"
    );
    this.paymentHistory_receiptElectroni_button = getLimit(
      "paymentHistory_receiptElectroni_button"
    );
    this.findList();
  },
  methods: {
    async findList() {
      await this.getTableDataList(arpaTransferTwo);
    },
    async lookReceipt(code) {
      const rLoading = this.openLoading();
      let response = await lookReceiptTwo({ code });
      rLoading.close();
      let url = response.data;
      if (url && url.length !== 0) {
        this.$refs.displayImg.show(url);
      } else {
        return this.$message({ message: "暂无回单", type: "warning" });
      }
    },

    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },

    // 翻译
    formatterField({ cellValue }, prefix) {
      const item = this.parentData[`${prefix}Options`].find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },

    hideModel() {
      this.ModelCashMoney = false;
      this.findList();
    }
  }
};
</script>

<style lang="scss" scoped>
.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
</style>
